import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
 getSectionsByAgenda,
 createSection,
 updateSection,
 deleteSection,
 getQuestionsBySection,
 createQuestion,
 updateQuestion,
 deleteQuestion,
} from "../../services/adminSessionAgendaServices";

const AgendaItemPage = () => {
 const { agendaId } = useParams();
 const navigate = useNavigate();

 const [sections, setSections] = useState([]);
 const [loading, setLoading] = useState(true);
 const [newSection, setNewSection] = useState({ title: "", orderIndex: 0 });
 const [newQuestion, setNewQuestion] = useState({ questionText: "", orderIndex: 0 });

 /* ===============================
 Load Sections & Questions
 =============================== */
 const loadSections = async () => {
 try {
 setLoading(true);
 const res = await getSectionsByAgenda(agendaId);
 const sectionsWithQuestions = await Promise.all(
 res.data.map(async (section) => {
 const qRes = await getQuestionsBySection(section.id);
 return { ...section, questions: qRes.data || [] };
 })
 );
 setSections(sectionsWithQuestions);
 } catch (err) {
 // setSections([]);
 } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 loadSections();
 }, [agendaId]);

 /* ===============================
 Section CRUD
 =============================== */
 const handleCreateSection = async () => {
 if (!newSection.title) return;
 await createSection(agendaId, newSection);
 setNewSection({ title: "", orderIndex: 0 });
 loadSections();
 };

 const handleUpdateSection = async (section) => {
 await updateSection(section.id, { title: section.title, orderIndex: section.orderIndex });
 loadSections();
 };

 const handleDeleteSection = async (sectionId) => {
 if (!window.confirm("Delete this section?")) return;
 await deleteSection(sectionId);
 loadSections();
 };

 /* ===============================
 Question CRUD
 =============================== */
 const handleCreateQuestion = async (sectionId) => {
 if (!newQuestion.questionText) return;
 await createQuestion(sectionId, newQuestion);
 setNewQuestion({ questionText: "", orderIndex: 0 });
 loadSections();
 };

 const handleUpdateQuestion = async (question) => {
 await updateQuestion(question.id, {
 questionText: question.questionText,
 orderIndex: question.orderIndex,
 });
 loadSections();
 };

 const handleDeleteQuestion = async (questionId) => {
 await deleteQuestion(questionId);
 loadSections();
 };

 if (loading) return <p>Loading sections...</p>;

 return (
 <div style={{ padding: "20px" }}>
 <h3>Agenda: {agendaId}</h3>

 {/* Add New Section */}
 <div style={{ marginBottom: "20px", padding: "10px", border: "1px solid #ccc" }}>
 <input
 placeholder="Section Title"
 value={newSection.title}
 onChange={(e) => setNewSection({ ...newSection, title: e.target.value })}
 style={{ marginRight: "10px" }}
 />
 <input
 type="number"
 placeholder="Order Index"
 value={newSection.orderIndex}
 onChange={(e) => setNewSection({ ...newSection, orderIndex: Number(e.target.value) })}
 style={{ width: "80px", marginRight: "10px" }}
 />
 <button onClick={handleCreateSection}>➕ Add Section</button>
 </div>

 {/* Sections List */}
 {sections.map((section) => (
 <div
 key={section.id}
 style={{ border: "1px solid #ccc", marginBottom: "10px", padding: "10px" }}
 >
 <div style={{ display: "flex", alignItems: "center" }}>
 <input
 value={section.title}
 onChange={(e) =>
 setSections((prev) =>
 prev.map((s) => (s.id === section.id ? { ...s, title: e.target.value } : s))
 )
 }
 style={{ flex: 1, marginRight: "10px" }}
 />
 <input
 type="number"
 value={section.orderIndex}
 onChange={(e) =>
 setSections((prev) =>
 prev.map((s) =>
 s.id === section.id ? { ...s, orderIndex: Number(e.target.value) } : s
 )
 )
 }
 style={{ width: "80px", marginRight: "10px" }}
 />
 <button onClick={() => handleUpdateSection(section)} style={{ marginRight: "5px" }}>
 💾
 </button>
 <button onClick={() => handleDeleteSection(section.id)}>🗑️</button>
 </div>

 {/* Questions List */}
 <div style={{ marginTop: "10px", paddingLeft: "20px" }}>
 <h5>Questions</h5>
 {section.questions.map((q) => (
 <div key={q.id} style={{ display: "flex", marginBottom: "5px" }}>
 <input
 value={q.questionText}
 onChange={(e) =>
 setSections((prev) =>
 prev.map((s) =>
 s.id === section.id
 ? {
 ...s,
 questions: s.questions.map((ques) =>
 ques.id === q.id ? { ...ques, questionText: e.target.value } : ques
 ),
 }
 : s
 )
 )
 }
 style={{ flex: 1, marginRight: "10px" }}
 />
 <input
 type="number"
 value={q.orderIndex}
 onChange={(e) =>
 setSections((prev) =>
 prev.map((s) =>
 s.id === section.id
 ? {
 ...s,
 questions: s.questions.map((ques) =>
 ques.id === q.id
 ? { ...ques, orderIndex: Number(e.target.value) }
 : ques
 ),
 }
 : s
 )
 )
 }
 style={{ width: "80px", marginRight: "10px" }}
 />
 <button onClick={() => handleUpdateQuestion(q)} style={{ marginRight: "5px" }}>
 💾
 </button>
 <button onClick={() => handleDeleteQuestion(q.id)}>🗑️</button>
 </div>
 ))}

 {/* Add New Question */}
 <div style={{ display: "flex", marginTop: "10px" }}>
 <input
 placeholder="New Question"
 value={newQuestion.questionText}
 onChange={(e) =>
 setNewQuestion({ ...newQuestion, questionText: e.target.value })
 }
 style={{ flex: 1, marginRight: "10px" }}
 />
 <input
 type="number"
 placeholder="Order Index"
 value={newQuestion.orderIndex}
 onChange={(e) =>
 setNewQuestion({ ...newQuestion, orderIndex: Number(e.target.value) })
 }
 style={{ width: "80px", marginRight: "10px" }}
 />
 <button onClick={() => handleCreateQuestion(section.id)}>➕ Add Question</button>
 </div>
 </div>
 </div>
 ))}

 <button onClick={() => navigate(-1)} style={{ marginTop: "20px" }}>
 ⬅ Back
 </button>
 </div>
 );
};

export default AgendaItemPage;
